import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import DataStoreDataProvider from '../../App/Components/Table/DataProvider/DataStoreDataProvider'
import { default as TableComponent } from '../../App/Components/Table/Table'
import TableColumn from '../../App/Components/Table/TableColumn'
import { useAppDispatch, useAppSelector } from '../../App/Hooks/reduxHooks'
import { activeEstablishmentSelector } from '../../Establishment/Store/reducer'
import { getPreferences } from '../../Preference/Store/actions'
import ActivityDataStore from '../DataStore/ActivityDataStore'
import { getActivityCategories } from '../store/actions'
import Spinner from '../../App/Components/Spinner/Spinner'
import { useGetDeviceListQuery } from '../../Calendar/Device/util/useDeviceQuery'
import { getUsers } from '../../User/Store/actions'

export const CabinAndDeviceActivityTable = () => {
  const [dataProvider, setDataProvider] = useState<any>()
  const { t } = useTranslation()
  const dispatch = useAppDispatch()

  const { data: devices } = useGetDeviceListQuery()

  const { preferences, activityCategories, cabins, areUsersInitiated } =
    useAppSelector(state => ({
      preferences: state.preferences.list,
      activityCategories: state.activities.activityCategories.list,
      cabins: state.users.list.filter(user => user.isCabin),
      areUsersInitiated: state.users.loading || state.users.list.length > 0,
    }))

  const establishment = useAppSelector(activeEstablishmentSelector)

  useEffect(() => {
    if (!preferences) {
      dispatch(getPreferences(establishment.uuid))
    }
    if (!activityCategories) {
      dispatch(getActivityCategories())
    }
    if (!areUsersInitiated) {
      dispatch(getUsers())
    }
    setDataProvider(
      new DataStoreDataProvider(
        ActivityDataStore,
        'getActivitiesForBulkEdit',
        'updateActivity',
        false,
      ),
    )
  }, [])

  const categoryMap: { [name: number]: string } = {}
  for (let activityCategory of activityCategories || []) {
    categoryMap[activityCategory.id] = activityCategory.name
  }

  const columns = []
  columns.push(
    <TableColumn dataKey={'name'} collapsable={false} key={'columnName'}>
      {t('Name')}
    </TableColumn>,
  )

  columns.push(
    <TableColumn
      dataKey={'category_id'}
      transform={(value: any) => categoryMap[value] || t('No category')}
      key={'columnCategory'}>
      {t('Category')}
    </TableColumn>,
  )

  for (let device of devices || []) {
    columns.push(
      <TableColumn
        dataKey={'device_' + device.uuid}
        editable
        key={'columnDevice' + device.uuid}
        isCheckbox={true}
        sortable={false}>
        {device.name}
      </TableColumn>,
    )
  }

  for (let cabin of cabins) {
    columns.push(
      <TableColumn
        dataKey={'cabin_' + cabin.uuid}
        editable
        key={'columnDevice' + cabin.uuid}
        isCheckbox={true}
        sortable={false}>
        {cabin.firstName + ' ' + cabin.lastName}
      </TableColumn>,
    )
  }

  if (!dataProvider) {
    return <Spinner />
  }

  return (
    <>
      <h2>{t('Bulk edit cabins and devices of activities')}</h2>
      <a href={'/settings/activities'}>&laquo; {t('Back')}</a>

      <TableComponent dataProvider={dataProvider} pageSize={25}>
        {columns}
      </TableComponent>
    </>
  )
}
